import CreateRoutes from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <CreateRoutes />
      <ToastContainer />
    </>
  );
}

export default App;
